<template>
  <img :src="imageSrc" v-bind="$attrs" ref="image" :class="{'lazy-image': true, 'lazy-image-loaded': loaded}" @load="onLoad"/>
</template>

<script>
export default {
  props: ['src', 'srcPlaceholder', 'intersectionOptions'],
  data() {
    return {
      observer: null,
      isIntersected: false,
      loaded: false,
    }
  },
  computed: {
    imageSrc() {
      return this.isIntersected ? this.src : this.srcPlaceholder;
    }
  },
  methods: {
    onLoad() {
      if(this.isIntersected)
        this.loaded = true;
    }
  },
  mounted() {
    if("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver((entries) => {
        if(entries.some((entry) => entry.isIntersecting)) {
          this.isIntersected = true;
          this.observer.disconnect();
        }
      }, this.intersectionOptions);
      this.observer.observe(this.$refs.image);
    }
  },
  unmounted() {
    if("IntersectionObserver" in window && this.observer) {
      this.observer.disconnect();
    }
  }
}
</script>